import _toConsumableArray from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Category from "./InputCategory.vue";
import Products from "./Products.vue";
import ShoppingCard from "./shopping-card/ShoppingCard.vue";
import CreateOrder from "./createOrder/CreateOrder.vue";
import providerApiService from "../../../services/api/ProviderApiService";
import { mapGetters } from "vuex";
import FetchError from "./../../../services/api/FetchError";
import { isMobileView } from "../../../helpers/Functions";
export default {
  name: "Input",
  data: function data() {
    return {
      FetchError: FetchError,
      data: null,
      activeCategory: null,
      showCreateOrderPopup: false,
      shoppingCard: [],
      swiperOption: {
        allowTouchMove: isMobileView()
      }
    };
  },
  components: {
    Category: Category,
    Products: Products,
    ShoppingCard: ShoppingCard,
    CreateOrder: CreateOrder
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    currentProvider: "profile/currentProvider"
  })), {}, {
    shoppingCardInfo: function shoppingCardInfo() {
      var shoppingCardInfo = this.shoppingCard.reduce(function (accumulator, product) {
        var findProductIndex = accumulator.findIndex(function (i) {
          return i.product ? i.product.id === product.id : false;
        });

        if (findProductIndex > -1) {
          accumulator[findProductIndex].unit++;
          accumulator[findProductIndex].price += product.price.discountDistinct(product.discount);
        } else {
          accumulator.push({
            product: product,
            unit: 1,
            price: product.price.discountDistinct(product.discount)
          });
        }

        return accumulator;
      }, []);
      var finalPrice = shoppingCardInfo.map(function (i) {
        return i.price;
      }).reduce(function (accumulator, currentValue) {
        return accumulator + currentValue;
      }, 0);
      var products = shoppingCardInfo.sort(function (a, b) {
        return a.product.categoryLevel - b.product.categoryLevel;
      });
      return {
        products: products,
        finalPrice: finalPrice
      };
    },
    isVerticalNavMenuActive: {
      get: function get() {
        return this.$store.state.isVerticalNavMenuActive;
      }
    }
  }),
  mounted: function mounted() {
    var _this = this;

    if (this.value) {
      this.shoppingCard = this.value.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          categoryLevel: item.level
        });
      });
    }

    providerApiService.menu(this.currentProvider.id).then(function (res) {
      _this.data = res.data;
      if (res.data[0]) _this.activeCategory = res.data[0];
    }).catch(function (err) {
      _this.data = err;
    });
  },
  props: {
    order: {
      type: Object
    },
    value: {
      type: Array
    }
  },
  watch: {
    activeCategory: function activeCategory(item) {
      var categoryIndex = this.data.findIndex(function (element) {
        return element.id === item.id;
      });
      var swiper = this.getSwiperSelector();

      if (swiper) {
        // Now you can use all slider methods like
        swiper.slideTo(categoryIndex, 0, false);
      }
    }
  },
  methods: {
    resetData: function resetData() {
      this.activeCategory = this.data[0];
      this.showCreateOrderPopup = false;
      this.shoppingCard = [];
    },
    addProduct: function addProduct(product) {
      if (product.price === 0) {
        this.$vs.notify({
          text: "این محصول فاقد قیمت میباشد و امکان اضافه کردن به سبد خرید را ندارد.",
          color: "warning",
          position: "bottom-center"
        });
        return;
      }

      this.shoppingCard = [].concat(_toConsumableArray(this.shoppingCard), [_objectSpread(_objectSpread({}, product), {}, {
        categoryLevel: this.activeCategory.level,
        categoryId: this.activeCategory.id
      })]);
    },
    removeProduct: function removeProduct(product) {
      this.shoppingCard.splice(this.shoppingCard.findIndex(function (item) {
        return item.id === product.id;
      }), 1);
    },
    handleShowCreateOrderPopup: function handleShowCreateOrderPopup() {
      this.showCreateOrderPopup = true;
    },
    slideChange: function slideChange() {
      var swiper = this.getSwiperSelector();

      if (swiper) {
        // Now you can use all slider methods like
        this.activeCategory = this.data[swiper.activeIndex];
      }
    },
    getSwiperSelector: function getSwiperSelector() {
      var swiperHtml = document.querySelector(".swiper");

      if (swiperHtml) {
        return swiperHtml.swiper;
      }

      return null;
    }
  }
};